<template>
  <v-container grid-list-md text-xs-left v-if="user !== null">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{user.surname}} {{user.first_name}} {{user.patronymic}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-layout column>
          <v-flex>
            <v-card flat class="pa-5 ma-3">

              <v-layout row class="mb-4">
                <v-flex xs6>
                  <v-avatar
                      :tile="false"
                      :size="72"
                      color="grey lighten-4"
                      class="ma-3 float-left"
                  >
                    <img :src="user.photo.url_resized" alt="avatar">
                  </v-avatar>
                  <div>
                    <p class="title mt-4">{{user.surname}} {{user.first_name}} {{user.patronymic}}</p>
                    <p class="body-2 mt-3" v-if="user.user_group !== null">{{user.user_group.title}}</p>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-4">
                <v-flex xs6>
                  <div>
                    <span class="title float-left">Телефон: </span>
                    <v-text-field
                        class="user-self-info-masked-input"
                        :value="user.phone"
                        mask="+7 (###) ###-##-##"
                        disabled
                    ></v-text-field>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-4" v-if="user.email !== '' && user.email !== null && typeof user.email !== 'undefined'">
                <v-flex xs6>
                  <div>
                    <span class="title">E-mail: </span>
                    <span class="title font-weight-thin">{{user.email}}</span>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-4" v-if="user.email === '' || user.email === null || typeof user.email === 'undefined'">
                <v-flex xs6>
                  <div>
                    <span class="title">E-mail: </span>
                    <span class="title font-weight-thin font-italic">не указан</span>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-4">
                <v-flex xs6>
                  <v-btn :to="'/users/self/edit'" color="warning" class="ma-0">Изменить данные</v-btn>
                </v-flex>
              </v-layout>

            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Личные данные'}
        ]
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      }
    },
    created () {
      this.$store.commit('setPageTitle', 'Личные данные')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserSelfInfo.vue